export const PMU_STYLES = [
  { n: "01", name: "Ombre Forte", desc: "Tökéletes, ha szereted a karakteresebb, poros hatású szemöldököt." },
  { n: "02", name: "Ombre Andante", desc: "Megfelelő számodra, ha szereted a sminkelt hatású szemöldököt." },
  { n: "03", name: "Ombre Misty", desc: "A természetes, de enyhén sminkelt hatás kedvelőinek bátran ajánlom." },
  { n: "04", name: "Hibrid szemöldök tetoválás", desc: "A legjobb azok számára, akiknek problémás a bőre, de mégis szeretnének szárazott tetoválást." },
  { n: "05", name: "Browlift – szárazott", desc: "Jó választás, ha szereted a természetes, kicsit kócos, dúsabb szemöldököt." },
  { n: "06", name: "Szárazott szemöldök", desc: "Akkor lesz tökéletes számodra, ha kedveled a természetes szemöldököt." },
];

export const PMU_BROW_PRICES = [
  "Ombre Forte",
  "Ombre Andante",
  "Ombre Misty",
  "Hibrid",
  "Szárazott",
  "Browlift",
  "Más munkája utáni javítás",
];

export const PMU_EXTRA_PRICES = [
  { name: "Szemhéj tetoválás", price: null },
  { name: "Lézeres tetoválás eltávolítás", price: "25 000 – 40 000 Ft / alkalom", note: "A pontos ár konzultáció után kerül meghatározásra." },
];

export const PMU_HEALING = [
  { day: "1. nap", text: "Friss, határozott szín — a terület enyhén piros és érzékeny lehet." },
  { day: "2–4. nap", text: "A szín erősödik, sötétebbnek tűnhet; vékony pikkelyréteg képződhet." },
  { day: "4–6. nap", text: "Megkezdődik a pikkelyes hámlás, viszkethet — tilos vakarni vagy lepiszkálni." },
  { day: "6–8. nap", text: "A hámlás befejeződik; a szín átmenetileg halványabbnak tűnhet." },
  { day: "8–14. nap", text: "A pigment fokozatosan visszaerősödik, kialakul a végleges tónus." },
  { day: "4–6. hét", text: "Kontroll és korrekció — itt tökéletesítjük a végeredményt." },
];

export const PMU_AFTERCARE_DO = [
  "A kapott utókezelő krémet vékony rétegben, tiszta kézzel, naponta 2–3 alkalommal vidd fel.",
  "Óvatosan, langyos vízzel tisztítsd a területet, majd tappintsuk szárazra — ne dörzsöld.",
  "Az első napokban aludj tiszta párnahuzaton, lehetőleg háton fekve.",
  "Gyógyulás után is védd fényvédővel a területet, hogy a szín sokáig szép maradjon.",
];

export const PMU_AFTERCARE_DONT = [
  "Ne vakard és ne piszkáld a képződő pikkelyeket — a pigment kihullhat velük.",
  "Gyógyulás alatt tilos a szauna, medence, szolárium és az intenzív, izzasztó edzés.",
  "Ne használj sminket vagy erős hatóanyagú kozmetikumot a kezelt területen.",
  "Ne napozz, és ne feszegesd, ne húzogasd a hámló bőrt.",
];

export const PMU_CONTRAINDICATIONS = [
  "Terhesség",
  "Szoptatás",
  "Lázas, beteg állapot",
  "Cukorbetegség",
  "Vérhígító szedése",
  "Aktív herpesz a területen",
  "Keloidra való hajlam",
  "Gyulladt, sérült bőr a területen",
];

export const LASER_NOTES = [
  { title: "Időpontválasztás", text: "Az ödéma miatt érdemes szabadnapok vagy hétvégék előttre foglalni." },
  { title: "Folyadékbevitel", text: "Kezelés előtt sok víz fogyasztása ajánlott a nyirokrendszer működéséhez." },
  { title: "Kezelések gyakorisága", text: "6–10 hetente ismétlendő folyamat." },
  { title: "Kísérők", text: "A lézersugár veszélyessége miatt kísérő nem hozható be (nincs védőszemüveg)." },
  { title: "Szemöldök", text: "Eltávolítás előtt semmiképpen se borotváld le a szőrt." },
  { title: "Részletek", text: "Az arc/test területén az első alkalommal 30%-os halványulás érhető el. Sminktetováláshoz 2–4, testtetováláshoz 5–8 alkalom kell. Időtartam: 10–40 perc, két kezelés között 6–8 hét." },
  { title: "Utókezelés", text: "Kezelés után átmeneti bőrpír és duzzanat lehetséges. 1 hónapig szigorúan tilos a szolárium, napozás, szauna és a bőr áztatása." },
];
